<template>
  <DialogTemplate data-gwmenu="noclose">
    <div
      class="py-2 px-2"
      style="max-width: 620px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('solfigr.sizes.bet_types') }}
      </div>
      <div class="help-grid-cont mt-4">
        <div
          v-for="item in options"
          :key="item.title"
        >
          <div class="item_title f-align-center mb-1 text-normal-large weight_600">
            {{ item.title }}
          </div>
          <div class="item_explanation clr-grey text-normal item_explanation_open">
            <div v-html="item.text"></div>
          </div>
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'StudyBetTypesHelpDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', this.dialog.dialog)
    },
  },
  computed: {
    options() {
      let res = [
        { id: 'bet_types_automatic' },
        { id: 'bet_types_dynamic' },
        { id: 'bet_types_fixed' },
      ]
      res = res.map(i => {
        const r = {
          id: i.id,
          title: this.$t(`solfigr.sizes.${i.id}`),
          text:
            i.id !== 'bet_types_dynamic'
              ? this.$t(`solfigr.sizes.${i.id}_text`)
              : this.$t('solfigr.sizes.bet_types_dynamic_text', {
                  dynamicLink: !this.$i18n.g1
                    ? `
            <i class="mdi mdi-information clr-primary"></i>
            <a target="_blank" class="text-small link-underline" tabindex="-1" href="https://blog.gtowizard.com/dynamic-sizing-benchmarks/">${this.$t(
              'solfigr.sizes.dynamic',
            )}</a>
            `
                    : '',
                }),
        }
        return r
      })
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.help-grid-cont {
  display: grid;
  grid-gap: 1rem;
}
.item {
  &_title {
    border-radius: 4px;
    display: flex;
    align-content: center;
    transition: 0.2s;
  }
  &_explanation {
    max-height: 0;
    will-change: max-height;
    overflow: hidden;
    &_open {
      transition: max-height 0.3s ease-in-out;
      max-height: 999px;
    }
  }
}
.blocker-icon {
  font-size: 1.5rem;
  line-height: 1;
}
</style>
